import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { localStateSelector, makePostSettingsSelector } from "../selectors";
import Component, { type BlogDetailPostProps } from "./component";
import { makeOverlayStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const overlayStyleSelector = makeOverlayStyleSelector();
  const postSettingsSelector = makePostSettingsSelector();

  return (state: AppState, props: RootContainerProps): BlogDetailPostProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      overlayStyle: overlayStyleSelector(state, props),
      post: localState.post!,
      settings: postSettingsSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
